import * as ParamTypes from './paramTypes';

export const isLift = exercise => {
    let defaultParamType = getDefaultParamType(exercise);
    return ParamTypes.weightParamTypes.includes(defaultParamType);
};

const getDefaultParamType = exercise => {
    let paramType1 = exercise.param_1_type;
    let paramType2 = exercise.param_2_type;
    if (paramType2 === ParamTypes.workoutParamTypes.NONE) {
        return paramType1;
    }
    if (paramType1 === ParamTypes.workoutParamTypes.NONE) {
        return paramType2;
    }
    if (paramType1 === ParamTypes.workoutParamTypes.REPS) {
        return paramType2;
    }
    return paramType1;
};



// WEBPACK FOOTER //
// ./src/lib/exerciseUtils.js